export default "__VITE_ASSET__4268eb45__"